<template>
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect x="2" y="13.0469" width="7.51504" height="7.75746" rx="0.636948" fill="currentColor" />
        <rect x="2" y="4.56641" width="7.51504" height="7.75746" rx="0.636948" fill="currentColor" />
        <rect x="10.4844" y="4.56641" width="7.51504" height="7.75746" rx="0.636948" fill="currentColor" />
        <rect x="10.4844" y="13.0469" width="7.51504" height="7.75746" rx="0.636948" fill="currentColor" />
    </svg>
</template>
